module.exports = __webpack_public_path__ + "img/LogotipoOpenpay_RGB-01 1.2e92960a.svg";